import { render, staticRenderFns } from "./product-details-activity.vue?vue&type=template&id=0b3705dd&scoped=true&"
import script from "./product-details-activity.vue?vue&type=script&lang=js&"
export * from "./product-details-activity.vue?vue&type=script&lang=js&"
import style0 from "./product-details-activity.vue?vue&type=style&index=0&id=0b3705dd&lang=scss&scoped=true&"
import style1 from "./product-details-activity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3705dd",
  null
  
)

export default component.exports